// 中文语言包
export default {
  settings: {
    title: '设置',
    hourFormat: '时间格式',
    scale: '缩放',
    brightness: '亮度',
    background: '背景',
    language: '语言',
    showSeconds: '显示秒数',
    pomodoro: '番茄钟设置'
  },
  timer: {
    stopwatch: '秒表',
    timer: '计时器',
    pomodoro: '番茄钟',
    customTimer: '自定义计时',
    start: '开始',
    pause: '暂停',
    reset: '重置',
    stop: '停止',
    shortBreak: '短休息',
    longBreak: '长休息',
    sessionsBeforeLongBreak: '多少个后休息'
  },
  pomodoro: {
    title: '番茄专注',
    workTime: '专注时间',
    breakTime: '休息时间',
    longBreakTime: '长休息时间',
    completedToday: '今日完成',
    totalCompleted: '累计完成',
    currentStreak: '连续天数',
    addNote: '添加备注',
    viewStats: '查看统计',
    exportData: '导出数据',
    importData: '导入数据',
    dataPanel: '数据面板'
  },
  stats: {
    title: '统计数据',
    today: '今天',
    thisWeek: '本周',
    thisMonth: '本月',
    total: '总计',
    pomodoroCount: '番茄数',
    focusTime: '专注时长',
    avgPerDay: '日均',
    chart: '趋势图表',
    noData: '暂无数据'
  },
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    export: '导出',
    import: '导入',
    success: '成功',
    error: '失败',
    default: '默认'
  },
  format: {
    hour12: '12',
    hour24: '24'
  }
}
